var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { useUserWorkspaces } from '#query-hooks';
// TODO: https://lucidlink.atlassian.net/browse/LUCID-28686
// This route guard can get stuck on a pending state if no data is available for the queiry which it uses to make decisions.
export const MemberRouteGuard = ({ children }) => {
    _react_refresh_temp_2();
    const { workspaceId = '' } = useParams();
    const { query: { data: userWorkspaceList, isLoading: isUserWorkspaceListLoading, }, } = useUserWorkspaces();
    if (isUserWorkspaceListLoading || !userWorkspaceList) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Checking workspace login status'), "data-testid": "checking-workspace-login-status", isFullHeight: true }) }));
    }
    const isMember = Boolean(userWorkspaceList?.find((wsData) => wsData.id === workspaceId));
    if (isMember) {
        return children;
    }
    return _jsx(Navigate, { to: `/workspaces` });
};
_react_refresh_temp_1 = MemberRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "MemberRouteGuard");
_react_refresh_temp_2(MemberRouteGuard, "uqGzV33iBpF0DkQc45ntak26ZFk=", false, () => [useParams, useUserWorkspaces]);
